module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-atami-2-fafe2a4d0da7eaa252a7d96716d95b6e.webp";